export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500">了解吃瓜爆料的初心与使命</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              吃瓜爆料成立于2023年，是国内领先的娱乐热点与爆料聚合平台。我们以<b>每日热点爆料吃瓜</b>为核心，汇集全网最新<b>吃瓜爆料黑料</b>、<b>吃瓜爆料视频</b>与<b>吃瓜爆料每日大赛</b>精彩内容，为亿万吃瓜群众提供真实、及时、全面的热门爆料资讯。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              作为国内最大的<b>吃瓜爆料黑料网</b>，我们拥有专业的编辑团队与严格的内容审核机制。每一条爆料都经过多方交叉验证，确保信息来源可靠。同时，我们为投稿者提供匿名安全的爆料通道，保护每一位勇敢发声的人。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              从娱乐圈秘闻到社会热点追踪，从网红翻车现场到行业黑幕揭秘，吃瓜爆料始终站在<b>爆料吃瓜</b>第一线。我们相信，信息的透明与公开是推动社会进步的重要力量。吃瓜，我们是认真的。
            </p>
          </div>
          <div className="rounded-xl overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20office%20composition%20with%20warm%20lighting%20and%20golden%20accents%2C%20dark%20crimson%20and%20deep%20brown%20tones%2C%20journalism%20and%20media%20aesthetic%2C%20professional%20newsroom%20atmosphere%2C%20cinematic%20composition%20with%20soft%20depth%20of%20field%2C%20no%20text%20no%20faces&width=700&height=500&seq=about-visual&orientation=landscape"
              alt="吃瓜爆料平台介绍"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}